import { graphql, useStaticQuery } from "gatsby"

const useOptions = () => {

  const data = useStaticQuery(graphql`
    query {
      footerCta: blockContentBookADemo( id: {eq: "522d1328-76a2-5308-a01b-ef29a72ca4f3"} ) {
        title: field_title
        link: field_link {
          title
          uri
        }
      }
    }
  `)

  return {
    footerCta: data.footerCta,
  }

  // data?.wp?.options?.options
}

export default useOptions
